import type { ControllerRenderProps } from 'react-hook-form'

import AsyncSelect from '@molecules/AsyncSelect'
import useQuery from '@hooks/useQuery'
import { EngagementLevelsIndexDocument } from '@frontend/graphql/queries/engagementLevels.generated'
import type { EngagementLevelsIndexQueryType } from '@frontend/graphql/queries/engagementLevels'

type EngagementLevelsSelectProps = {
  field: ControllerRenderProps<any, any>
  displayName: string
  hideLabel?: boolean
}

export default function EngagementLevelsSelect({ field, displayName, hideLabel }: EngagementLevelsSelectProps) {
  const response = useQuery<EngagementLevelsIndexQueryType>({
    key: 'engagementLevels',
    query: EngagementLevelsIndexDocument,
    variables: {},
  })

  const options = (response.data?.engagementLevels?.nodes ?? []).map((level) => ({
    value: level.name,
    label: level.name,
  }))

  return (
    <AsyncSelect
      dataTestId="engagement-levels-select"
      field={field}
      displayName={displayName}
      hideLabel={hideLabel}
      defaultOptions={options}
      loadOptions={async (inputValue: string) =>
        options.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()))
      }
      isCreatable={false}
      totalCount={options.length}
    />
  )
}
